<template>
  <v-footer app class="pa-3">
    <span class="font-weight-bold mr-1">{{ company }}</span>
    <span>&copy; {{ new Date().getFullYear() }}</span>
    <v-spacer></v-spacer>
    <span class="caption font-italic">Versão: {{ version }}</span>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
  data: () => ({
    company: 'Syclus Tecnologia',
    version: '2.0.025.7'
  })
}
</script>

<style>

</style>